import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { Property, PropertySelector } from '../drawer/propertySelector/PropertySelector';
import { SearchStateProps } from '../Assistant';
import { usePropertiesInEnterpriseChainId } from './usePropertiesInEnterpriseChainId';

interface PropertySelectorStateProps {
    selectedProperty?: Property;
    selectedPropertiesIds: Array<string>;
}

export const usePropertySelectorComponent = (setSearchState: Dispatch<SetStateAction<SearchStateProps>>) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const [state, setState] = useState<PropertySelectorStateProps>({
        selectedPropertiesIds: [],
        selectedProperty: undefined,
    });
    const { selectedProperty, selectedPropertiesIds } = state;
    const { propertiesId: propertiesIds, properties } = usePropertiesInEnterpriseChainId();

    return useMemo(() => {
        const enterpriseIds = selectedPropertiesIds?.length > 0 ? [...selectedPropertiesIds] : [currentEnterpriseId];

        const updateParentState = () => {
            setSearchState((prev) => ({
                ...prev,
                focused: true,
            }));
        };

        const handlePropertySelect = (property: Property) => {
            setState((prevState) => ({
                ...prevState,
                selectedProperty: property,
                selectedPropertiesIds: [property.id],
            }));
            updateParentState();
        };

        const handleAllPropertiesSelect = () => {
            setState((prevState) => ({
                ...prevState,
                selectedProperty: undefined,
                selectedPropertiesIds: propertiesIds,
            }));
            updateParentState();
        };

        return {
            propertySelectorComponent:
                properties.length > 1 ? (
                    <PropertySelector
                        properties={properties}
                        selectedProperty={selectedProperty}
                        handlePropertySelect={handlePropertySelect}
                        handleAllPropertiesSelect={handleAllPropertiesSelect}
                    />
                ) : null,
            enterpriseIds,
        };
    }, [currentEnterpriseId, properties, propertiesIds, selectedPropertiesIds, selectedProperty, setSearchState]);
};
